<script>
  import Avatar from "../../common/Avatar";
  import ToolTip from "../atoms/ToolTip.vue";
  export default {
    name: "UserTag",
    components: { Avatar, ToolTip },
    props: {
      user: {
        type: Object,
        required: true,
      },
      modifier: {
        type: String,
        default: "",
      },
      showOnlyAvatar: {
        type: Boolean,
        default: false,
      },
      avatarStyles: {
        type: Object,
        default: () => {},
      },
      tooltipVariant: {
        type: String,
        default: "default",
      },
      canShowTooltip: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        showTooltip: false,
      };
    },
    methods: {
      handleMouseInteraction(state) {
        if (!this.canShowTooltip) return;
        this.showTooltip = state;
      },
    },
  };
</script>

<template>
  <div :class="`userTag userTag--${modifier}`" @mouseenter="handleMouseInteraction(true)" @mouseleave="handleMouseInteraction(false)">
    <Avatar class="userTag__avatar" :user="user" :style="avatarStyles" />
    <div class="userTag__info" v-if="!showOnlyAvatar">
      <span class="userTag__name">{{ user.user }}</span>
      <span v-if="user.isFixedMonitor" class="userTag__role">Monitor fijo</span>
    </div>
    <ToolTip v-show="showTooltip" :text="user.user" :variant="tooltipVariant" />
  </div>
</template>

<style lang="scss">
  .userTag {
    @include Flex();
    position: relative;
    padding: 5px 7px;
    gap: 6px;
    border-radius: 50px;
    background: #f0f0f0;
    &__avatar {
      width: 20px;
      height: 20px;
      object-fit: cover;
      border-radius: 50%;
      border: 1px solid $primary-color;
    }
    &__name {
      color: #242424;
      font-size: 16px;
    }
    &__role {
      color: #bd0909;
      font-size: 10px;
      font-weight: 600;
    }
    &--dropdown {
      background: none;
      justify-content: flex-start;
      gap: 10px;

      & .userTag__avatar {
        width: 25px;
        height: 25px;
      }
    }
    &--card {
      .userTag__avatar {
        border: none;
      }
      padding: 2px;
      background: $gold-gradient;
    }
  }
</style>
